import axios from 'axios'

import { CMS_ADAPTER_URL } from '../constants/url'
import { getPinflagApiKey } from './utils'

const cmsInstance = axios.create({
  baseURL: CMS_ADAPTER_URL,
  headers: { 'x-api-key': getPinflagApiKey() }
})

export default cmsInstance
